import { KeyOf } from '~/types';

export const breakpoint = {
  mobile_small: '375px',
  mobile_middle: '480px',
  mobile_large: '768px',
  desktop: '1080px',
  desktop_large: '1920px',
} as const;

export const mediaQuery = {
  mobile_375: `@media (max-width: ${breakpoint.mobile_small})`,
  mobile_480: `@media (max-width: ${breakpoint.mobile_middle})`,
  mobile_768: `@media (max-width: ${breakpoint.mobile_large})`,
  desktop_1080: `@media (max-width: ${breakpoint.desktop})`,
  desktop_1920: `@media (max-width: ${breakpoint.desktop_large})`,
  desktop_over: `@media (min-width: ${breakpoint.desktop_large})`,
} as const;

export const matchMediaQuery = {
  mobile_375: `(max-width: ${breakpoint.mobile_small})`,
  mobile_480: `(max-width: ${breakpoint.mobile_middle})`,
  mobile_768: `(max-width: ${breakpoint.mobile_large})`,
  desktop_1080: `(max-width: ${breakpoint.desktop})`,
  desktop_1920: `(max-width: ${breakpoint.desktop_large})`,
  desktop_over: `(min-width: ${breakpoint.desktop_large})`,
} as const;

export type MediaQuery = typeof mediaQuery;
export type MediaQueryKeys = KeyOf<typeof mediaQuery>;
